import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal, CUSTOM_ELEMENTS_SCHEMA, ElementRef, viewChild, PLATFORM_ID, AfterViewInit, OnInit } from '@angular/core';

import { HomePageGalleryBoxComponent } from './home-page-gallery-box/home-page-gallery-box.component';

import { AppService } from '../../app.service';
import { Dictionary, groupBy } from 'lodash';
import { isPlatformBrowser, KeyValuePipe, NgOptimizedImage } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { BlogsListComponent } from '../../blogger/blogs-list/blogs-list.component';
import { SwiperContainer } from 'swiper/element/bundle';
import { Swiper, SwiperOptions } from 'swiper/types';
import { RouterLink } from '@angular/router';

const defaultSlide = {
    bgImage: undefined,
    video: undefined,
    videoSrc: undefined,
    imgSrc: 'assets/header.webp',
    name: 'header',
    body: null,
};
@Component({
    selector: 'iea-app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [KeyValuePipe, RouterLink, NgOptimizedImage, BlogsListComponent, HomePageGalleryBoxComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    standalone: true,
})
export default class HomeComponent implements AfterViewInit, OnInit {
    readonly appService = inject(AppService);
    viewerSwiperRef = viewChild<ElementRef<SwiperContainer>>('viewerSwiperRef');
    viewerSwiper?: Swiper;

    // browser id
    private readonly platformId = inject(PLATFORM_ID);
    isBrowser = isPlatformBrowser(this.platformId);

    types = new Map<string, any>();
    galleryBoxes = signal<Dictionary<any[]>>(null);
    blogs = signal([]);
    slides = signal([defaultSlide]);
    sliderInitialized = signal(false);
    ngOnInit() {
        this.appService.slides().then((slides) => {
            this.slides.set(slides.length === 0 ? [defaultSlide] : slides);
        });
        this.loadArticles();
        this.loadBoxes();
    }
    async ngAfterViewInit() {
        if (this.isBrowser) {
            const m = await import('swiper/element/bundle');
            m.register();
            this.sliderInitialized.set(true);
            this.initViewerSwiper();
        }
    }

    readonly destroyRef = inject(DestroyRef);
    async loadBoxes() {
        const types = await firstValueFrom(this.appService.artBoardsTypes);
        types.forEach((cat) => this.types.set(cat._id, cat));
        const artBoards = await this.appService.getHomePageGallery(types.map((t) => t._id));
        this.galleryBoxes.set(groupBy(artBoards, 'category'));
    }
    async loadArticles() {
        const blogs = await this.appService.getBlogs();
        this.blogs.set(blogs);
    }

    initViewerSwiper() {
        viewerConfig.loop = this.slides().length > 2;
        return makeSwiper(this.viewerSwiperRef(), viewerConfig);
    }
}

function makeSwiper(ref: ElementRef<SwiperContainer>, conf: SwiperOptions) {
    Object.assign(ref.nativeElement, conf);
    ref.nativeElement.initialize();
    return ref.nativeElement.swiper;
}
const viewerConfig: SwiperOptions = {
    init: false,
    spaceBetween: 10,
    direction: 'horizontal',
    autoplay: {
        delay: 10000,
        pauseOnMouseEnter: true,
    },
    slidesPerView: 1,
    keyboard: {
        enabled: true,
    },
    navigation: true,
};
